import { createContext } from 'react';

import type { CalendarModalState } from '@app/providers/CalendarModalProvider/CalendarModalProvider.types';

export const CalendarModalContext = createContext<CalendarModalState>({
  lastClickedEmployeeData: null,
  setLastClickedEmployeeData: () => {},
  lastClickedWorkBreak: null,
  setLastClickedWorkBreak: () => {},
  isWorkScheduleModalOpen: false,
  setIsWorkScheduleModalOpen: () => {},
  isWorkScheduleModalLoading: false,
  setIsWorkScheduleModalLoading: () => {},
  breakModalType: '',
  setBreakModalType: () => {},
  isBreakModalOpen: false,
  setIsBreakModalOpen: () => {},
  isBreakModalLoading: false,
  setIsBreakModalLoading: () => {},
  editEmployeeScheduleModalType: '',
  setEditEmployeeScheduleModalType: () => {},
  isEditEmployeeScheduleModalOpen: false,
  setIsEditEmployeeScheduleModalOpen: () => {},
  isEditEmployeeScheduleModalLoading: false,
  setIsEditEmployeeScheduleModalLoading: () => {},
  editEmployeeScheduleModalEditingAlertString: '',
  setEditEmployeeScheduleModalEditingAlertString: () => {},
  editEmployeeScheduleModalDeletingAlertString: '',
  setEditEmployeeScheduleModalDeletingAlertString: () => {},
  editEmployeeScheduleModalInitialEditingData: null,
  setEditEmployeeScheduleModalInitialEditingData: () => {},
  editingWorkScheduleForm: null,
  breakForm: null,
});
